// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__EXX8x","loader":"Loader_loader__CKl1y","loading":"Loader_loading__+Qd3P"};